<div class="panel-content-table">
    <p-table #dt [filterDelay]="0" [paginator]="true" editMode="row" [rows]="10" [value]="templates"
        [rowTrackBy]="trackByFn" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
        [(selection)]="selectedTemplate" [tableStyle]="{ 'min-width': '50rem' }"
        [globalFilterFields]="['bsrtType', 'bsrt', 'subtype']"
        (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)">
        <ng-template pTemplate="caption">
            <div class="flex">
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{ 'Search keyword' | translate }}" />
                </span>
                <app-table-tool-bar [buttons]="toolBarButtons" [buttonsMenu]="toolBarButtonsMenu"
                    [mobile]="false"></app-table-tool-bar>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr *ngIf="loadingTemplates">
                <td [attr.colspan]="7">
                    <mat-progress-bar class="content-progress-bar" color="primary"
                        mode="indeterminate"></mat-progress-bar>
                </td>
            </tr>
            <tr>
                <th style="width: 4rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>{{"BSRT Type" | translate}}</th>
                <th>{{"BSRT" | translate}}</th>
                <th>{{"Subtype" | translate}}</th>
                <th>{{"Automatic" | translate}}</th>
                <th>{{"Active" | translate}}</th>
                <th>{{"View Template" | translate}}</th>

            </tr>
            <tr>
                <th></th>
                <th>
                    <p-columnFilter type="text" field="bsrtType"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="bsrt"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="subtype"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="boolean" field="automatic"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="boolean" field="active"></p-columnFilter>
                </th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
            <tr>
                <td>
                    <p-tableCheckbox [value]="template"></p-tableCheckbox>
                </td>
                <td>{{ template.bsrtType | translate}}</td>
                <td>{{ getBsrtName(template.bsrtType, template.bsrt) }}</td>
                <td>{{ template.subtype }}</td>
                <td>
                    <mat-icon *ngIf="template.automatic">check_small</mat-icon>
                    <mat-icon *ngIf="!template.automatic" class="check">close</mat-icon>
                </td>
                <td>
                    <mat-icon *ngIf="!template.deactivated">check_small</mat-icon>
                    <mat-icon *ngIf="template.deactivated" class="check">close</mat-icon>
                </td>
                <td>
                    <button pButton pRipple type="button" type="button" class="visibility-button"
                        (click)="viewTemplateFolder(template)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </tr>
        </ng-template>
        @if(!templates.length){
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" style="text-align: center; padding: 2rem;">
                    <div class="empty-message">
                        <i class="pi pi-inbox" style="font-size: 3rem; color: var(--text-color-secondary);"></i>
                        <p>{{"No templates found" | translate}}</p>
                    </div>
                </td>
            </tr>
        </ng-template>
        }
    </p-table>

    <p-dialog [(visible)]="displayDialog" [style]="{width: '450px'}" header="{{'Template Details' | translate}}"
        [modal]="true" [draggable]="false" [dismissableMask]="false" styleClass="p-fluid"
        (onHide)="removeWritePermission()">
        <ng-template pTemplate="content">
            <div class="p-field">
                <label for="bsrttype">{{"BSRT Type" | translate}}</label>

                <p-select [options]="bsrtTypes" [(ngModel)]="templateDialog.bsrtType"
                    placeholder="{{ 'Select BSRT Type' | translate }}" (onChange)="onBsrtTypeChange()" appendTo="body">
                    <ng-template let-type pTemplate="item">
                        {{ type | translate }}
                    </ng-template>
                </p-select>
            </div>
            <div class="p-field">
                <label for="bsrt">{{"BSRT" | translate}}</label>
                <p-select [options]="bsrtOptions" [(ngModel)]="templateDialog.bsrt" optionLabel="name"
                    optionValue="code" [disabled]="!bsrtOptions.length" placeholder="{{ 'Select BSRT' | translate }}"
                    appendTo="body" required></p-select>
            </div>
            <div class="p-field">
                <label for="subtype">{{"Subtype" | translate}}</label>
                <p-select [options]="subtypeOptions" [(ngModel)]="templateDialog.subtype" optionLabel="name"
                    optionValue="code" [disabled]="true" placeholder="{{ 'Select Subtype' | translate }}"
                    appendTo="body" required>
                </p-select>
            </div>
            <div class="p-field">
                <label for="automatic" class="p-checkbox-label">{{"Automatic" | translate}}</label>
                <p-toggleSwitch [(ngModel)]="templateDialog.automatic" inputId="automatic"></p-toggleSwitch>
            </div>

        </ng-template>

        <ng-template pTemplate="footer">
            <div *ngIf="templateDialog.folderURL" class="mt-3">
                <button pButton pRipple type="button" icon="pi pi-eye" label="{{'Edit Template' | translate}}"
                    class="p-button-text p-button-sm" (click)="editTemplateFolder(templateDialog)">
                </button>
            </div>
            <button pButton pRipple label="{{'Save' | translate}}" icon="pi pi-check" class="p-button-text"
                (click)="saveTemplate()"></button>
        </ng-template>
    </p-dialog>


    <p-dialog [(visible)]="showEditPermissionDialog" [modal]="true" [dismissableMask]="false" [draggable]="false"
        header="{{'Please click save after finishing' | translate}}" [style]="{width: '400px'}">
        <div>
            <p>
                {{"So you don't lose your changes, please click save after finishing." | translate}}
            </p>
        </div>
    </p-dialog>

    <div class="confirmation-button">
        <p-toast></p-toast>
        <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
    </div>
</div>